import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
let GoodsInfo = class GoodsInfo extends Vue {
    constructor() {
        super(...arguments);
        this.activityNamesAry = 0;
        this.showAll = true;
        this.isVip = false;
    }
    activityNamesChanged(val = []) {
        console.log('rrrr', val);
        this.activityNamesAry = val.length || 0;
    }
    get isApp() {
        return env.type === 'ivydad' || env.type === 'web';
    }
    get goodsInfo() {
        return this.products[0] || {};
    }
    get giftFilter() {
        let giftsActivity = this.products[0] ? this.products[0].giftsActivity : {};
        let gift = giftsActivity.gift || [];
        return gift.filter(i => !i.soldOut);
    }
    get giftMaterial() {
        return index => {
            return this.giftFilter[index]
                ? this.giftFilter[index].material_ids
                : false;
        };
    }
    get productsFilter() {
        return this.isCart
            ? []
            : this.products.filter(i => i.goods_type === 'goods_gift');
    }
    get isCart() {
        return this.$route.query.isCart === 'true';
    }
    get cartProducts() {
        let products = this.products;
        return this.showAll ? products : products.slice(0, 1);
    }
    get isDistribution() {
        return (this.products[0].activity &&
            this.products[0].activity.distribution &&
            this.products[0].activity.distribution.id);
    }
    async created() {
        await env.init();
        if (!(await env.getIsLogin())) {
            return await env.login();
        }
        let loginfo = await env.getInfo();
        // alert(JSON.stringify(loginfo))
        if (this.isApp) {
            if (loginfo.userInfo && loginfo.userInfo.isVip == '1')
                this.isVip = true;
        }
        else {
            if (loginfo.logined && loginfo.logined.vip)
                this.isVip = true;
        }
    }
    showMore() {
        this.showAll = true;
    }
};
tslib_1.__decorate([
    Prop({ default: () => [] })
], GoodsInfo.prototype, "products", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], GoodsInfo.prototype, "cartInfo", void 0);
tslib_1.__decorate([
    Prop()
], GoodsInfo.prototype, "activityNames", void 0);
tslib_1.__decorate([
    Prop()
], GoodsInfo.prototype, "goldData", void 0);
tslib_1.__decorate([
    Watch('activityNames', { deep: true, immediate: true })
], GoodsInfo.prototype, "activityNamesChanged", null);
GoodsInfo = tslib_1.__decorate([
    Component
], GoodsInfo);
export default GoodsInfo;
